import { Box, InputAdornment, TextField } from '@mui/material';
import { useLocation } from 'react-router-dom';
import React, { useContext, useState } from 'react';
import Fuse from 'fuse.js';
import SearchIcon from '@mui/icons-material/Search';
import { GarmentObject } from '../types/reducers/filterReducer';
import { LoggingContext } from '../Context/LoggingContext/LoggingContext';

function SearchResultsInput({
  externalFilteredGarmentObjects,
  localSearchResults,
  setLocalSearchResults,
}: {
  externalFilteredGarmentObjects: GarmentObject[];
  setLocalSearchResults: React.Dispatch<React.SetStateAction<GarmentObject[]>>;
  localSearchResults: GarmentObject[];
}) {
  const location = useLocation();
  const { addLog } = useContext(LoggingContext);
  const [textSearchInputState, setTextSearchInputState] = useState('');

  // Initialise fuzzy search object
  const fuse = React.useMemo(
    () =>
      new Fuse(externalFilteredGarmentObjects, {
        keys: ['manufacturer', 'description'],
      }),
    [externalFilteredGarmentObjects]
  );
  // Fuzzy search with input to filter results
  React.useEffect(() => {
    // Set debounce to improve performance
    const delayDebounceFn = setTimeout(() => {
      if (textSearchInputState.length === 0) {
        if (externalFilteredGarmentObjects.length === localSearchResults.length) return;
        setLocalSearchResults(externalFilteredGarmentObjects);
      } else if (textSearchInputState.length > 0) {
        addLog(`searching text in input: ${textSearchInputState}`, location.pathname);
        const fuseSearchResult = fuse
        .search(textSearchInputState)
        .map((thisFuseResult) => thisFuseResult.item);
        if (
          fuseSearchResult.length === localSearchResults.length &&
          fuseSearchResult.every((val, index) => val === localSearchResults[index])
          )
          return;
          setLocalSearchResults(fuseSearchResult);
          addLog(`searching text in input: ${textSearchInputState}`, location.pathname);
      }
    }, 250);
    return () => clearTimeout(delayDebounceFn);
  }, [textSearchInputState]);

  return (
    <Box sx={{ margin: '16px 16px' }}>
      <TextField
        value={textSearchInputState}
        onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
          setTextSearchInputState(event.target.value);
        }}
        autoFocus
        label='Search Garments'
        variant='outlined'
        InputProps={{
          startAdornment: (
            <InputAdornment position='start'>
              <SearchIcon />
            </InputAdornment>
          ),
        }}
      />
    </Box>
  );
}

export default SearchResultsInput;
